import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';
@Pipe({ name: 'OrderBy' })
export class OrderByPipe implements PipeTransform {
  transform(value: any[], order = '', column: string = ''): any[] {
    if (!value || order === '' || !order) { return value; } // no array
    if (value.length <= 1) { return value; } // array with only one item
    if (!column || column === '') { 
      if(order==='desc'){return value.sort().reverse();}
      else{return value.sort();}
    } // sort 1d array
    return orderBy(value, [column], [order]);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/pipe/orderBy.Pipe.ts